import React from "react";

export class SliceZone extends React.Component {
  render() {
    if (this.props.content && this.props.slices) {
      return this.props.content.map((contentItem, index) => {
        if (
          contentItem &&
          contentItem.slice_type &&
          this.props.slices[contentItem.slice_type]
        ) {
          return (
            <React.Fragment>
              {this.props.divider && this.props.divider}
              {React.createElement(this.props.slices[contentItem.slice_type], {
                key: "slice" + index,
                ...this.props.sliceProps,
                ...contentItem,
              })}
            </React.Fragment>
          );
        } else {
          return null;
        }
      });
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SliceZone/SliceZone.js